export const ADD_ITEMS_TO_SHOPPING_CART = 'ADD_ITEMS_TO_SHOPPING_CART ';
export const DELETE_ITEM_TO_SHOPPING_CART = 'DELETE_ITEM_TO_SHOPPING_CART ';
export const SUBMIT_ITEM_TO_SHOPPING_CART = 'SUBMIT_ITEM_TO_SHOPPING_CART ';
export const ADD_PERSONAL_DATA_TO_SHOPPING_CART = 'ADD_PERSONAL_DATA_TO_SHOPPING_CART ';
export const DELETE_ITEM_TO_SHOPPING_CART_BY_ID = 'DELETE_ITEM_TO_SHOPPING_CART_BY_ID';
export const CHANGE_IS_GITFT = 'CHANGE_IS_GITFT';
export const ADD_NOTES = 'ADD_NOTES';
export const USE_CRIS_DATA = 'USE_CRIS_DATA';
export const ADD_ID_EXP = 'ADD_ID_EXP';
export const RESET_CART = 'RESET_CART';
